<p-table #patientTable [value]="patients" class="emr-table" styleClass="data-table" [loading]="loading"
  [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]"
  responsiveLayout="scroll" [paginator]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} patients" [filterDelay]="0"
  [globalFilterFields]="tableFilterFields" selectionMode="multiple" (onRowSelect)="onRowSelect($event)"
  (onRowUnselect)="onRowUnselect($event)">
  <ng-template pTemplate="caption">
    <div class="table-header">
      <p-iconfield iconPosition="left" class="ml-auto">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input pInputText type="text" (input)="filterTable($event.target)" placeholder="Search patients" />
      </p-iconfield>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="isAdmin" style="width: 3rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th pSortableColumn="mrn">
        <div class="flex justify-content-between align-items-center">
          MRN
          <p-sortIcon field="mrn"></p-sortIcon>
          <p-columnFilter type="text" field="mrn" display="menu" class="ml-auto"></p-columnFilter>
        </div>
      </th>
      <th pSortableColumn="firstName">
        <div class="flex justify-content-between align-items-center">
          First Name
          <p-sortIcon field="firstName"></p-sortIcon>
          <p-columnFilter type="text" field="firstName" display="menu" class="ml-auto"></p-columnFilter>
        </div>
      </th>
      <th pSortableColumn="lastName">
        <div class="flex justify-content-between align-items-center">
          Last Name
          <p-sortIcon field="lastName"></p-sortIcon>
          <p-columnFilter type="text" field="lastName" display="menu" class="ml-auto"></p-columnFilter>
        </div>
      </th>
      <th pSortableColumn="generalInfo.patientType">
        <div class="flex justify-content-between align-items-center">
          Type
          <p-sortIcon field="generalInfo.patientType"></p-sortIcon>
          <p-columnFilter type="text" field="generalInfo.patientType" display="menu" class="ml-auto"></p-columnFilter>
        </div>
      </th>
      <th pSortableColumn="generalInfo.roomNumber">
        <div class="flex justify-content-between align-items-center">
          Room #
          <p-sortIcon field="generalInfo.roomNumber"></p-sortIcon>
          <p-columnFilter type="text" field="generalInfo.roomNumber" display="menu" class="ml-auto"></p-columnFilter>
        </div>
      </th>
      <th pSortableColumn="generalInfo.location">
        <div class="flex justify-content-between align-items-center">
          Location
          <p-sortIcon field="generalInfo.location"></p-sortIcon>
          <p-columnFilter type="text" field="generalInfo.location" display="menu" class="ml-auto"></p-columnFilter>
        </div>
      </th>

    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-patient>
    <tr class="p-selectable-row">
      <td *ngIf="isAdmin">
        <p-tableCheckbox [value]="patient"></p-tableCheckbox>
      </td>
      <td>
        {{ patient.mrn }}
      </td>
      <td> {{ patient.firstName }} </td>
      <td> {{ patient.lastName }} </td>
      <td> {{ patient.generalInfo.patientType }} </td>
      <td> {{ patient.generalInfo.roomNumber }} </td>
      <td> {{ patient.generalInfo.location }} </td>
      <td style="text-align: center">
        <button pButton type="button" class="p-button-primary" icon="pi pi-arrow-right" pTooltip="View patient"
          (click)="navigateToPatient(patient.id)"></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr *ngIf="isAdmin">
      <td colspan="8" style="text-align: center; padding: 3rem">
        You currently have no patients. Click the "New Patient" button to get started!
      </td>
    </tr>
    <tr *ngIf="!isAdmin">
      <td colspan="8" style="text-align: center; padding: 3rem">No patients assigned.</td>
    </tr>
  </ng-template>
</p-table>